import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/SchedulingPage.css';

const SchedulingPage = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().slice(0, 10));
  const [appointments, setAppointments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the appointments for the selected date
    // (You'll need to implement the actual data fetching logic)
    const appointmentsForSelectedDate = [
      {
        device: 'Room 1 - Device 1',
        therapist: 'Amy',
        customerName: 'John Doe',
        treatment: 'Bel-Air Signature Massage',
        startTime: '20230501090000',
        duration: '1hour',
      },
      {
        device: 'Room 2 - Device 1',
        therapist: 'Bella',
        customerName: 'Jane Smith',
        treatment: 'Hot Stone Massage',
        startTime: '20230501113000',
        duration: '45mins',
      },
    ];
    setAppointments(appointmentsForSelectedDate);
  }, [selectedDate]);

  const handleCreateAppointment = () => {
    navigate('/scheduling/create');
  };

  return (
    <div className="scheduling-container">
      <main className="scheduling-content">
        <h1 className="scheduling-title">Scheduling</h1>
        <div className="scheduling-tools">
          <label className="scheduling-label">Date:</label>
          <input
            type="date"
            className="scheduling-date-input"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
          <button className="scheduling-button" onClick={handleCreateAppointment}>
            Create New Appointment
          </button>
        </div>
        <div className="scheduling-appointments">
          <h2 className="scheduling-appointments-title">Current Appointments</h2>
          <ul className="scheduling-appointments-list">
            {appointments.map((appointment, index) => (
              <li key={index} className="scheduling-appointment-item">
                <div className="scheduling-appointment-info">
                  {appointment.device} - {appointment.therapist} - {appointment.customerName} -{' '}
                  {appointment.treatment} - {appointment.startTime} - {appointment.duration}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </main>
    </div>
  );
};

export default SchedulingPage;